<template>
  <v-card class="rounded-corners" max-width="600px">
    <v-img
      :src="$filters.assetUrl('assets/upselling/upsell-header.png')"
      max-height="250px"
      max-width="1490px"
    />
    <v-toolbar flat density="compact" class="pa-3" color="transparent">
      <v-toolbar-title class="bold-text">
        {{ $t('upselling.readyForPro') }}
      </v-toolbar-title>
      <v-btn
        class="ma-0 pa-0"
        icon
        data-cy="x-close-button"
        @click="closeDialog()"
      >
        <v-icon> mdi-close </v-icon>
      </v-btn>
    </v-toolbar>
    <div class="mx-8 mb-4">
      {{ $t('upselling.upsellDescription') }}
    </div>
    <v-divider />
    <v-card-actions class="mx-3 button-row">
      <v-btn
        variant="flat"
        color="primary"
        class="text-none ma-1"
        @click="navigateToUpgradePage()"
      >
        {{ $t('upselling.upgradeButton') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { captureComparePlans } from '@/util/posthog';

export default defineComponent({
  name: 'UpsellingCard',
  emits: ['close'],
  methods: {
    async navigateToUpgradePage() {
      await this.$router.push('/plan-overview');
      captureComparePlans();
    },
    closeDialog() {
      this.$emit('close');
    }
  }
});
</script>

<style scoped lang="scss">
.button-row {
  justify-content: flex-end;
}
</style>
